import React, { FC } from 'react';
import classes from './ViewDetailsButton.tailwind';

interface IViewDetailsButtonProps {
  title: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  Icon?: React.ReactElement;
  'data-id'?: string;
}

export const ViewDetailsButton: FC<IViewDetailsButtonProps> = ({ title, onClick, Icon, ...rest }) => {
  return (
    <button className={`${classes.buttonContainer} bg-azureish-white`} onClick={onClick} {...rest}>
      {Icon}
      {title}
    </button>
  );
};
